import { useState, useEffect, useCallback } from 'react';

/**
 * Reusable hook for fullscreen toggle functionality
 * 
 * Provides:
 * - isFullscreen state
 * - handleFullscreenToggle function
 * - ESC key handling to exit fullscreen
 * 
 * Usage:
 * const { isFullscreen, handleFullscreenToggle } = useFullscreenToggle();
 */
const useFullscreenToggle = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleFullscreenToggle = useCallback(() => {
        setIsFullscreen((prev) => !prev);
    }, []);

    // Handle ESC key to exit fullscreen
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape" && isFullscreen) {
                setIsFullscreen(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isFullscreen]);

    return {
        isFullscreen,
        handleFullscreenToggle,
    };
};

export default useFullscreenToggle;
